import { render, staticRenderFns } from "./MultiMenuItem.vue?vue&type=template&id=b66f54ae"
import script from "./MultiMenuItem.vue?vue&type=script&lang=ts"
export * from "./MultiMenuItem.vue?vue&type=script&lang=ts"
import style0 from "./MultiMenuItem.vue?vue&type=style&index=0&id=b66f54ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports